import { Location } from 'msp-cost-calculator';

/**
 * Transforms the array of reference sites into a form the cost calculator can use
 */
export default class Transformer {

  /**
   * Transform reference site objects to objects known by the cost calculator
   * @param referenceSites
   * @returns {Array}
   */
  static transformReferenceSites(referenceSites) {
    return Object.keys(referenceSites).map((key) => {
      const site = referenceSites[key];
      return new Location(
        site.id,
        site.name,
        site.lat,
        site.lon
      )
    });
  }

  /**
   * Transform an array of selected features into an array of IDs
   * @param selectedFeatures
   */
  static transformSelectedFeatures(selectedFeatures) {
    return Object.keys(selectedFeatures).map((key) => selectedFeatures[key].id);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/trips-costs/transformer.js